//
// HOME
//

export const HOME_SET_NAME_GEOJSON = 'HOME_SET_NAME_GEOJSON';
export const HOME_SET_MAP = 'HOME_SET_MAP';
export const HOME_SET_GEOJSON = 'HOME_SET_GEOJSON';
export const HOME_SET_STATUS_GEOJSON = 'HOME_SET_STATUS_GEOJSON';
export const HOME_SET_GEOJSON_ERROR = 'HOME_SET_GEOJSON_ERROR';

export const HOME_SET_LISTS = 'HOME_SET_LISTS';
export const HOME_SET_LISTS_CUSTOMMAPS = 'HOME_SET_LISTS_CUSTOMMAPS';

export const HOME_SET_HISTORY = 'HOME_SET_HISTORY';

export const HOME_SET_STREAMER_MODE = 'HOME_SET_STREAMER_MODE';
//
// GAME (area)
//
export const GAME_SET_AREAS = 'GAME_SET_AREAS';
export const GAME_SET_LOADING_AREAS = 'GAME_SET_LOADING_AREAS';
export const GAME_SET_URL_AREAS = 'GAME_SET_URL_AREAS';

//
// Settings
//
export const SETTINGS_SET_GAME_SETTINGS = 'SETTINGS_SET_GAME_SETTINGS';
export const SETTINGS_SET_DIFFICULTY = 'SETTINGS_SET_DIFFICULTY';
export const SETTINGS_SET_BBOX = 'SETTINGS_SET_BBOX';
export const SETTINGS_SET_PLAYER_NAME = 'SETTINGS_SET_PLAYER_NAME';
export const SETTINGS_RESET = 'SETTINGS_RESET';

//
// Alert
//
export const ALERT_SET_ALERT = 'ALERT_SET_ALERT';
